import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import urls from "@/app-js/urls";
import snackbar from "./modules/snackbar";
import auth from "./modules/auth";

Vue.use(Vuex);

export default () => {
  return new Vuex.Store({
    state: () => ({
      support_contact: "+91 9340660727",
      sort_list: "Popularity",
      page_loader: false,
      is_splash_call_pending: false,
      splash_called: false,
      login_dialog: false,
      common_dialog: false,
      language: "English",
      mycard_page_title: "",
      show_footer: true,
      freeInviteHTML: ""
    }),

    mutations: {
      SET_PAGE_LOADER(state, value) {
        state.page_loader = value;
      },

      SET_IS_SPLASH_CALL_PENDING(state, value) {
        state.is_splash_call_pending = value;
      },

      SET_SPLASH_CALLED(state, value) {
        state.splash_called = value;
      },

      SET_LOGIN_DIALOG(state, value) {
        state.login_dialog = value;
      },

      SET_COMMON_DIALOG(state, value) {
        state.common_dialog = value;
      },

      SET_SHOW_FOOTER(state, value) {
        state.show_footer = value;
      },

      SET_SUPPORT_CONTACT(state, value) {
        state.support_contact = value;
      },

      SET_SORT_LIST(state, value) {
        state.sort_list = value;
      },

      SET_FREE_INVITE_HTML(state, value) {
        state.freeInviteHTML = value;
      }
    },

    actions: {
      async callSplash({ commit, dispatch }) {
        const access_token = require("js-cookie").get("token");

        commit("SET_IS_SPLASH_CALL_PENDING", true);
        const params = {
          country: "India",
          country_code: "IN",
          language: "en",
          access_token
        };
        const response = (
          await axios.get(urls.SPLASH, {
            baseURL: urls.BASE_URL,
            params
          })
        ).data;

        dispatch("auth/setAccessToken", response.access_token, {
          root: true
        });
        commit("SET_SUPPORT_CONTACT", response.support_contact);
        commit("SET_IS_SPLASH_CALL_PENDING", false);
        commit("SET_SPLASH_CALLED", true);
      },

      startLoader({ state, commit }) {
        if (!state.page_loader) commit("SET_PAGE_LOADER", true);
      },

      stopLoader({ state, commit }) {
        if (state.page_loader) commit("SET_PAGE_LOADER", false);
      },

      setLoginDialog({ commit }, value) {
        commit("SET_LOGIN_DIALOG", value);
      },

      setCommonDialog({ commit }, value) {
        commit("SET_COMMON_DIALOG", value);
      },

      setShowFooter({ commit }, value) {
        commit("SET_SHOW_FOOTER", value);
      },

      async fetchFreeInviteHTML({ commit }, { card_table_id }) {
        const params = {
          card_table_id
        };
        const response = await this.$axios.get(urls.FREE_INVITE_PREVIEW, {
          params
        });
        if (
          response.headers["content-type"] === "application/json" &&
          response.data.success === false
        )
          throw Error(response.data.message);

        commit("SET_FREE_INVITE_HTML", response.data);
      }
    },

    modules: {
      snackbar,
      auth
    }
  });
};
